
import { Component, Vue } from "vue-property-decorator";
import { CashOrderStatusEnum, ICashOrderDTO } from "@/entities";
import ApprovalsFilter, { IApprovalsFilterModel } from "@/components/approvals/ApprovalsFilter.vue";
import ApprovalsTable from "@/components/approvals/ApprovalsTable.vue";
import { IApprovalsParams } from "@/services";
import IconApprovals from "@/components/common/icon/IconApprovals.vue";

@Component({
  name: "approvals-page",
  components: {
    IconApprovals,
    ApprovalsFilter,
    ApprovalsTable,
  },
})
export default class ApprovalsPage extends Vue {
  orders: ICashOrderDTO[] = [];

  filters: IApprovalsFilterModel = this.defaultFilters();

  mounted(): void {
    this.fetchOrders();
  }

  get pending(): ICashOrderDTO[] {
    return this.orders.filter((o) => o.status === CashOrderStatusEnum.PENDING_APPROVAL);
  }

  get approved(): ICashOrderDTO[] {
    return this.orders.filter((o) => o.status === CashOrderStatusEnum.APPROVED_APPROVAL);
  }

  get rejected(): ICashOrderDTO[] {
    return this.orders.filter((o) => o.status === CashOrderStatusEnum.REJECTED_APPROVAL);
  }

  async fetchOrders(): Promise<void> {
    const params: IApprovalsParams = {
      status: this.filters.status,
      username: this.filters.username,
      serviceCode: this.filters.serviceCode,
      orderDateFrom: this.toIsoStartOfDay(this.filters.orderDateFrom),
      orderDateTo: this.toIsoEndOfDay(this.filters.orderDateTo),
    };

    const res = await this.$services.approvals.getOrders(params);
    this.orders = res || [];
  }

  private defaultFilters(): IApprovalsFilterModel {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const from = new Date(today);
    from.setDate(from.getDate() - 7);

    return {
      status: [],
      username: undefined,
      serviceCode: undefined,
      orderDateFrom: from,
      orderDateTo: today,
    };
  }

  private toIsoStartOfDay(d: Date): string {
    const tmp = new Date(d);
    tmp.setHours(0, 0, 0, 0);
    return tmp.toISOString();
  }

  private toIsoEndOfDay(d: Date): string {
    const tmp = new Date(d);
    tmp.setHours(23, 59, 59, 999);
    return tmp.toISOString();
  }
}
